import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.p`
  margin: 0;
  padding-bottom: 10px;
  display: flex;
  align-items: top;
  width: 100%;
  color: ${props => props.theme.secondaryColor};
  font: ${props => props.theme.fontWeightMedium} ${props => (props.largeFont ? 17 : 14)}px/100% ${props => props.theme.fontFamilyBody};

  & > span.fa-stack {
    color: ${props => props.theme.primaryColor};
    font-size: 16px;
    line-height: 16px;
    height: 16px;
    width: 16px;
    margin: 2px 14px 0 0;
    ${props => !props.largeFont && `
      margin-top: -1px;
    `};
    display: flex;
    align-items: center;
    justify-content: center;

    > .fa-stack-2x {
      font-size: 18px;
      position: relative;
      left: 50%;
    }

    > .fa-stack-1x {
      font-size: 9px;
      position: relative;
      left: -1px;
    }
  }

  & > span:not(.fa-stack) {
    flex-grow: 6;
  }
`;

export default function Tip({ text, largeFont }) {
  return (
    <Container className="tip-container" largeFont={largeFont}>
      <span className="fa-stack fa-lg">
        <i className="fa fa-circle-thin fa-stack-2x" />
        <i className="fa fa-info fa-stack-1x" />
      </span>
      <span>
        {text}
      </span>
    </Container>
  );
}

Tip.propTypes = {
  text: PropTypes.string.isRequired,
  largeFont: PropTypes.bool,
};

Tip.defaultProps = {
  largeFont: true,
};
